// extracted by mini-css-extract-plugin
export default {"desktopMinWidth":"1280","mobileMaxWidth":"700","mobileMaxHeightLandscape":"480","siderFixedHeightPhone":"49px","zIndexModal":"3090"};